import { useState } from "react";

// Real product icon from local /public/logos asset. Falls back to a clean
// branded-initial tile if the image is missing/broken.
export function ProductIcon({ product, className = "", rounded = "rounded-xl" }) {
  const [broken, setBroken] = useState(false);
  const showImage = product.iconUrl && !broken;

  if (showImage) {
    return (
      <div
        className={`flex items-center justify-center overflow-hidden bg-white/95 ${rounded} ${className}`}
      >
        <img
          src={product.iconUrl}
          alt={`Logo ${product.name}`}
          loading="lazy"
          onError={() => setBroken(true)}
          className="h-full w-full object-contain p-1.5"
        />
      </div>
    );
  }

  return (
    <div
      role="img"
      aria-label={`Logo ${product.name}`}
      className={`flex items-center justify-center bg-nm-surface2 text-nm-text font-extrabold ${rounded} ${className}`}
    >
      <span aria-hidden="true">{product.initials}</span>
    </div>
  );
}
